function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ThesauriFormField from "./ThesauriFormField";
import ThesauriFormGroup from "./ThesauriFormGroup";

export class ThesauriFormItem extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.focus = () => this.groupItem && this.groupItem.focus();
  }

  render() {
    const { value } = this.props;
    if (value.values) {
      return /*#__PURE__*/(
        React.createElement(ThesauriFormGroup, _extends({
          ref: (f) => {
            this.groupItem = f;
          } },
        this.props)
        ));

    }
    return /*#__PURE__*/React.createElement(ThesauriFormField, this.props);
  }
}










export default ThesauriFormItem;